import React, { useContext, useState, useEffect } from "react";
import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import eventBgImg from "../../components/images/blog.jpg";
import ProjectsList from "../../components/Projects/ProjectsList";
import { animateScroll as scroll } from "react-scroll";
import { BackgroundImageTopOpacityBlog } from "../../components/BackgroundImage";
import {
  HeroH1White,
  HeroPBlog,
  HeroContainer,
  HeroContent,
  HeroPositionContainerBlog,
} from "../../components/Specialities/HeroSpecElements";
import { LanguageContext } from "../../components/LanguageContext";
import { OverflowContainer } from "../Home/HomeElements";

const ProjectsPage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [language, setLanguage] = useContext(LanguageContext);
  const toggle = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    (() => {
      scroll.scrollToTop();
    })();
  }, []);

  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle}></Sidebar>
      <Navbar toggle={toggle}></Navbar>{" "}
      <OverflowContainer>
        <HeroContainer>
          <BackgroundImageTopOpacityBlog
            backgroundImage={eventBgImg}
          ></BackgroundImageTopOpacityBlog>
          <HeroContent>
            <HeroPositionContainerBlog>
              <HeroH1White>
                {language[0].eng === "true" ? "UNIQUE PROJECTS" : "EGYEDI PROJEKTEK"}
              </HeroH1White>{" "}
              <HeroPBlog>
                {language[0].eng === "true"
                  ? "Exploring the intersections of music with other art forms and sensory experiences."
                  : "A zene és más művészeti formák, valamint érzékszervi élmények metszéspontjainak felfedezése."}
              </HeroPBlog>
              <HeroPBlog>
                {language[0].eng === "true"
                  ? "Where creativity transcends boundaries and sound meets innovation."
                  : "Ahol a kreativitás túllépi a határokat, és a hang találkozik az innovációval."}
              </HeroPBlog>
            </HeroPositionContainerBlog>
          </HeroContent>
        </HeroContainer>
        <ProjectsList></ProjectsList>{" "}
      </OverflowContainer>
      <Footer></Footer>
    </>
  );
};

export default ProjectsPage;
